module.exports = __webpack_public_path__ + "static/media/AvatarElwin.6e421dcf.png";